import { a as __makeTemplateObject, c as __rest, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { c as chevronUri } from './SelectBoxChevron-7d1ba535.js';
import { I as InputBox } from './InputBox-01bcc484.js';

var Select = styled.select(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  && {\n    background: right center url(", ") no-repeat;\n  }\n"], ["\n  cursor: pointer;\n  && {\n    background: right center url(", ") no-repeat;\n  }\n"])), chevronUri);
var templateObject_1;

var SelectBox = function (_a) {
    var defaultLabel = _a.defaultLabel, options = _a.options, inputAttributes = __rest(_a, ["defaultLabel", "options"]);
    return (jsxs(InputBox, __assign({ as: Select }, inputAttributes, { children: [typeof defaultLabel === 'string' && (jsx("option", { label: defaultLabel, value: "" }, void 0)), options.map(function (_a) {
                var key = _a.key, label = _a.label, value = _a.value;
                if (typeof value === 'string') {
                    return (jsx("option", __assign({ value: value }, { children: label }), key));
                }
                else {
                    return (jsx("optgroup", __assign({ label: label }, { children: value.map(function (_a) {
                            var optionKey = _a.key, optionLabel = _a.label, optionValue = _a.value;
                            if (typeof optionValue !== 'string') {
                                throw new Error('Cannot have options greater than a depth of 2.');
                            }
                            return (jsx("option", __assign({ value: optionValue }, { children: optionLabel }), optionKey));
                        }) }), key));
                }
            })] }), void 0));
};

export { SelectBox as S };
